import { render, staticRenderFns } from "./GenrePlace.vue?vue&type=template&id=5ce0059e&"
import script from "./GenrePlace.vue?vue&type=script&lang=js&"
export * from "./GenrePlace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports